export enum REQUEST_ACTION {
    RETURN = 'RETURN',
    OPERATION_ASSIGN = 'OPERATION_ASSIGN',
    OPERATION_REASSIGN = 'OPERATION_REASSIGN',
    OPERATION_COMPLETE = 'OPERATION_COMPLETE',
    CLOSE = 'CLOSE',
    OPEN='OPEN',
    ASSIGN='ASSIGN',
    REVOKE='REVOKE',
    OPERATION_OPEN='OPERATION_OPEN', 
    
}
